import { render } from "./PacmanOnboardingView.vue.ts?vue&type=template&id=83dbb64b&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PacmanOnboardingView.vue?vue&type=template&id=83dbb64b&scoped=true&ts=true"
import script from "./PacmanOnboardingView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PacmanOnboardingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PacmanOnboardingView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PacmanOnboardingView.vue?vue&type=script&setup=true&lang=ts"

import "./PacmanOnboardingView.vue.scss?vue&type=style&index=0&id=83dbb64b&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PacmanOnboardingView.vue?vue&type=style&index=0&id=83dbb64b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83dbb64b"],['__file',"src/apps/credit-line/views/Invitation/PacmanOnboardingView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83dbb64b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83dbb64b', __exports__)) {
    api.reload('83dbb64b', __exports__)
  }
  
  module.hot.accept("./PacmanOnboardingView.vue.ts?vue&type=template&id=83dbb64b&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PacmanOnboardingView.vue?vue&type=template&id=83dbb64b&scoped=true&ts=true", () => {
    api.rerender('83dbb64b', render)
  })

}


export default __exports__